define([
	"dojo/_base/array",
	"csi",
	"csi/html",
	"csi/locale",
	"csi/session",
	"csi/view",
	"csi/xml"
], function(array, csi, html, locale, session, view, xml) {

	return {
		onAccessActionShowRemarks: function(ctx, action) {
			return ctx.view.bShowRemarks;
		},

		onAccessActivityDetails: function(ctx, action) {
			// summary: can only popup activity details if on correct level
			if (!ctx.view.tooltipView) {
				return false;
			}
			return html.getDataAttribute(ctx.view.tooltipView.getRefNodeForAction(), html.DATA_CALENDAR_ACTIVITY_URL);
		},

		calendarGetPendingRequest: function(node, cache, parentNode, checkDelete) {
			// summary: find calendar requests for given node and draw status
			var requests = cache.getParents(xml.nodeGetURL(node), "RequestCalendar");
			if (requests) {
				requests = array.filter(requests, function(cr) {return xml.nodeGetType(cr) == "CalendarRequest";});
			}
			// Have to check that the request points to this node.
			if (parentNode && requests) {
				if (xml.nodeGetType(parentNode).indexOf("Calendar") >= 0) {
					parentNode = cache.getNode(parentNode.__Parent__, true);
				}
				requests = array.filter(requests, function(cr) {
					var pNode = cache.getNode(cr.ParentNode, true);
					if (pNode) return xml.nodeGetURL(pNode) == xml.nodeGetURL(parentNode);
					else return false;
				});
			}

			if (requests) {
				// sort by create time
				if (requests.length > 1) {
					requests = csi.sort(requests, function(cr) {
						return xml.nodeGetProperty(cr, xml.PROP_CREATE_TIME);
					});
				}

				if (requests.length && (xml.nodeGetAttributeValue(requests.last(), "RequestStatus") == "Pending")) {
					if (checkDelete) {
						var operation = xml.nodeGetAttributeValue(requests.last(), "Operation");
						var isDelete = operation && operation == "Delete";
						if (isDelete) {
							return requests.last();
						}
					} else {
						return requests.last();
					}
				}
			}

			return null;
		},

		calendarGetLatestRequest: function(node, cache, parentCalendarNode) {
			// summary: find calendar requests for given node and draw status
			var requests = cache.getParents(xml.nodeGetURL(node), "RequestCalendar");
			if (requests) {
				requests = array.filter(requests, function(cr) {return xml.nodeGetType(cr) == "CalendarRequest";});
			}

			// Check that the request points to this node.
			if (parentCalendarNode && requests && xml.nodeGetType(parentCalendarNode).indexOf("Calendar") >= 0) {
				var parentNode = cache.getNode(parentCalendarNode.__Parent__, true);
				if (parentNode) {
					requests = array.filter(requests, function(cr) {
						return cr.ParentNode == parentNode.$URL;
					});
				}
			}

			if (requests) {
				// sort by create time
				if (requests.length > 1) {
					requests = csi.sort(requests, function(cr) {
						return xml.nodeGetProperty(cr, xml.PROP_CREATE_TIME);
					});
				}

				if (requests.length) {
					return requests.last();
				}
			}

			return null;
		},

		onDrawParentNodeType: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			var nodeType = xml.nodeGetAttributeValue(ctx.getNode(), "ParentNodeType");
			if (nodeType) {
				html.setInnerText(refNode, locale.type(nodeType));
			}
		},

		onDrawMasterCalendarRequestStatus: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: find calendar requests for given node and draw status
			var request = this.calendarGetLatestRequest(ctx.getNode(), ctx.cache);
			if (request) {
				var value = xml.nodeGetAttributeValue(request, "RequestStatus");
				html.setInnerText(refNode, xml.nodeGetAttributeValue(request, "Operation") + " " + value);
			}
		},

		onDrawFrozenCalendarRequestStatus: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: find calendar requests for given node and draw status
			var parentNodeURL = view.getView("Calendar").getViewURL();
			var parentNode = ctx.cache.getNode(parentNodeURL, true);
			var request = this.calendarGetLatestRequest(ctx.getNode(), ctx.cache, parentNode);
			if (request) {
				var value = xml.nodeGetAttributeValue(request, "RequestStatus");
				html.setInnerText(refNode, xml.nodeGetAttributeValue(request, "Operation") + " " + value);
			}
		},

		onDrawCalendarRequestStatus: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: find calendar requests for given node's master and draw status
			var node = ctx.getNode();
			var request = this.calendarGetLatestRequest(node, ctx.cache, node);
			if (!request) {
				var masterNode = ctx.cache.getNode(node.Master, true);
				request = this.calendarGetLatestRequest(masterNode, ctx.cache, node);
			}

			if (request) {
				var value = xml.nodeGetAttributeValue(request, "RequestStatus");
				html.setInnerText(refNode, xml.nodeGetAttributeValue(request, "Operation") + " " + value);
			}
		},

		onAccessActionMasterCalendar: function(/*Context*/ctx, /*Action*/action) {
			// summary: check to make sure calendar is not already frozen or being deleted
			var node = ctx.getNode();
			return !xml.nodeIsFrozen(node) && !this.calendarGetPendingRequest(node, ctx.cache, null, true);
		},

		onAccessActionCalendarDelete: function(/*Context*/ctx, /*Action*/action) {
			// summary: check to make sure calendar is not already being deleted
			return !this.calendarGetPendingRequest(ctx.getNode(), ctx.cache, ctx.getNode(), true);
		},

		/**
		 * User must have admin access to frozen MasterCalendar for it to be applied
		 * @param {Context} ctx 
		 * @param {Action} action 
		 * @return {boolean}
		 */
		onAccessApplyMasterCalendar(ctx, action) {
			const masterCalendar = ctx.getNode();
			return masterCalendar.FreezeStatus && xml.nodeHasRight(masterCalendar, xml.RIGHT_ADMIN);
		},

		onAccessFreezeCalendarAction: function(/*Context*/ctx, /*Action*/action) {
			return !this.calendarGetPendingRequest(ctx.getNode(), ctx.cache);
		},

		onActionBrowseParent: function(/*Controller*/ac) {
			session.setLocationUrl(ac.getNode().Parent);
		},

		canAggregateCalendar: function(/*Context*/ctx, /*FormData*/fd) {
			return !this.calendarGetPendingRequest(ctx.getNode(), ctx.cache, fd.getParent());
		}
	};
});
